// extracted by mini-css-extract-plugin
export default {"container":"bra_1KZu7"};